// extracted by mini-css-extract-plugin
export default {"icon-color":"black","icon-size":"24","container":"financial-information_container__QvFTq","empty":"financial-information_empty__Tw0ot"};